function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { MAP, SHIFT_MAP, SPECIAL_ALIASES } from './AllKeysMap';
export var HotKey = function () {
  function HotKey() {
    _classCallCheck(this, HotKey);

    this.ele = typeof window !== 'undefined' ? document : null;
    this.callbacks = {};
    this.ele && this.bindEvent(this.ele);
  }

  _createClass(HotKey, [{
    key: "dispose",
    value: function dispose() {
      this.ele && this.unbindEvent(this.ele);
    }
  }, {
    key: "init",
    value: function init(ele) {
      if (ele && this.ele !== ele) {
        var old = this.ele;
        old && this.unbindEvent(old);
        this.bindEvent(ele);
        this.ele = ele;
      }
    }
  }, {
    key: "addHotKeys",
    value: function addHotKeys(hotKeys, callback, eventType) {
      var _this = this;

      var first = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      hotKeys.forEach(function (hotKey) {
        var info = _this.getHotKeyInfo(hotKey, eventType, callback);

        _this.callbacks[info.key] = _this.callbacks[info.key] || [];

        if (first) {
          _this.callbacks[info.key].unshift(info);
        } else {
          _this.callbacks[info.key].push(info);
        }
      });
    }
  }, {
    key: "removeHotKeys",
    value: function removeHotKeys(hotKeys, callback, eventType) {
      var _this2 = this;

      hotKeys.forEach(function (hotKey) {
        var info = _this2.getHotKeyInfo(hotKey, eventType, callback);

        var currentCbs = _this2.callbacks[info.key] || [];

        if (!currentCbs.length) {
          return;
        }

        var idx = null;
        currentCbs.some(function (item, i) {
          var modifiers = item.modifiers,
              cb = item.callback;

          if (_this2.modifiersEqual(modifiers, info.modifiers) && callback === cb) {
            idx = i;
            return true;
          }
        });

        if (idx != null) {
          currentCbs.splice(idx, 1);
        }
      });
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      e.__which__ = e.which || e.keyCode || e.charCode;
      var char = this.getCharFromEvent(e);

      if (!char) {
        return;
      }

      this.emitCallback(char, e);
    }
  }, {
    key: "bindEvent",
    value: function bindEvent(ele) {
      if (!ele) return;
      ele.addEventListener('keydown', this, false);
      ele.addEventListener('keypress', this, false);
      ele.addEventListener('keyup', this, false);
    }
  }, {
    key: "unbindEvent",
    value: function unbindEvent(ele) {
      ele.removeEventListener('keydown', this, false);
      ele.removeEventListener('keypress', this, false);
      ele.removeEventListener('keyup', this, false);
    }
  }, {
    key: "emitCallback",
    value: function emitCallback(char, e) {
      var modifiers = this.getEventModifiers(e);
      var cbs = this.getMatchesCallback(char, modifiers, e);
      var element = e.target || e.srcElement;

      if (this.stopCallback(e, element)) {
        return;
      }

      cbs.forEach(function (cb) {
        var callback = cb.callback,
            hotKey = cb.hotKey;

        if (callback(e, hotKey) === false) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }
  }, {
    key: "getMatchesCallback",
    value: function getMatchesCallback(char, modifiers, e) {
      var _this3 = this;

      var matches = [];
      var callbacks = this.callbacks[char] || [];

      if (!callbacks.length) {
        return matches;
      }

      callbacks.forEach(function (info) {
        var eventType = info.eventType,
            infoModifiers = info.modifiers;

        if (eventType !== e.type || !_this3.modifiersEqual(infoModifiers, modifiers)) {
          return;
        }

        matches.push(info);
      });
      return matches;
    }
  }, {
    key: "getCharFromEvent",
    value: function getCharFromEvent(e) {
      var code = e.__which__;

      if (e.type === 'keypress') {
        var char = String.fromCharCode(code);

        if (!e.shiftKey) {
          return char.toLowerCase();
        }

        return char;
      }

      if (MAP[code] || SHIFT_MAP[code]) {
        return MAP[code] || SHIFT_MAP[code];
      }

      return String.fromCharCode(code).toLowerCase();
    }
  }, {
    key: "getEventModifiers",
    value: function getEventModifiers(e) {
      var modifiers = [];

      if (e.altKey) {
        modifiers.push('alt');
      }

      if (e.ctrlKey) {
        modifiers.push('ctrl');
      }

      if (e.metaKey) {
        modifiers.push('meta');
      }

      if (e.shiftKey) {
        modifiers.push('shift');
      }

      return modifiers;
    }
  }, {
    key: "modifiersEqual",
    value: function modifiersEqual(modifersA, modifiersB) {
      return modifersA.sort().join(',') === modifiersB.sort().join(',');
    }
  }, {
    key: "isModifier",
    value: function isModifier(char) {
      return char === 'shift' || char === 'alt' || char === 'meta' || char === 'ctrl';
    }
  }, {
    key: "getHotKeyInfo",
    value: function getHotKeyInfo(hotKey, eventType, callback) {
      var _this4 = this;

      var keys = hotKey.replace(/\+{2}/, '+plus').split('+');
      var modifiers = [];
      var key = '';
      keys.forEach(function (item) {
        key = item;

        if (SPECIAL_ALIASES[key]) {
          key = SPECIAL_ALIASES[key];
        }

        if (eventType !== 'keypress' && SHIFT_MAP[key]) {
          key = SHIFT_MAP[key];
          modifiers.push('shift');
        }

        if (_this4.isModifier(key)) {
          modifiers.push(key);
        }
      });
      return {
        key: key,
        keys: keys,
        hotKey: hotKey,
        modifiers: modifiers,
        eventType: this.getBestEventType(modifiers, eventType),
        callback: callback
      };
    }
  }, {
    key: "getBestEventType",
    value: function getBestEventType(modifiers, type) {
      if (type === 'keypress' && modifiers.length) {
        return 'keydown';
      }

      return type;
    }
  }, {
    key: "stopCallback",
    value: function stopCallback(e, element) {
      if (!this.ele) {
        return true;
      }

      if (this.contains(element, this.ele)) {
        return false;
      }

      var tagName = element.tagName.toUpperCase();
      return tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA' || element.isContentEditable;
    }
  }, {
    key: "contains",
    value: function contains(ele, ancestor) {
      if (ele == null || ele === document) {
        return false;
      }

      if (ele === ancestor) {
        return true;
      }

      return this.contains(ele.parentNode, ancestor);
    }
  }]);

  return HotKey;
}();